module.exports = __webpack_public_path__ + "media/application/images/circle-facebook-62999933b976b50fe53ef8395916870f.svg";